/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadStatus } from './LeadStatus';
import {
    LeadStatusFromJSON,
    LeadStatusFromJSONTyped,
    LeadStatusToJSON,
    LeadStatusToJSONTyped,
} from './LeadStatus';

/**
 * 
 * @export
 * @interface FindAllLeadStatuses200Response
 */
export interface FindAllLeadStatuses200Response {
    /**
     * 
     */
    data?: Array<LeadStatus>;
}

/**
 * Check if a given object implements the FindAllLeadStatuses200Response interface.
 */
export function instanceOfFindAllLeadStatuses200Response(value: object): value is FindAllLeadStatuses200Response {
    return true;
}

export function FindAllLeadStatuses200ResponseFromJSON(json: any): FindAllLeadStatuses200Response {
    return FindAllLeadStatuses200ResponseFromJSONTyped(json, false);
}

export function FindAllLeadStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeadStatuses200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadStatusFromJSON)),
    };
}

export function FindAllLeadStatuses200ResponseToJSON(json: any): FindAllLeadStatuses200Response {
    return FindAllLeadStatuses200ResponseToJSONTyped(json, false);
}

export function FindAllLeadStatuses200ResponseToJSONTyped(value?: FindAllLeadStatuses200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadStatusToJSON)),
    };
}

